module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/array-buffer-native.js
// module id = 193
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33